module.exports = __webpack_public_path__ + "static/media/badEmoji.2453eb8f.svg";